var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_2475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM12.5 23.4375C6.45937 23.4375 1.5625 18.5406 1.5625 12.5C1.5625 6.45937 6.45937 1.5625 12.5 1.5625C18.5406 1.5625 23.4375 6.45937 23.4375 12.5C23.4375 18.5406 18.5406 23.4375 12.5 23.4375Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 10.1562C9.4567 10.1562 10.1562 9.4567 10.1562 8.59375C10.1562 7.73081 9.4567 7.03125 8.59375 7.03125C7.73081 7.03125 7.03125 7.73081 7.03125 8.59375C7.03125 9.4567 7.73081 10.1562 8.59375 10.1562Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 10.1562C17.2692 10.1562 17.9688 9.4567 17.9688 8.59375C17.9688 7.73081 17.2692 7.03125 16.4062 7.03125C15.5433 7.03125 14.8438 7.73081 14.8438 8.59375C14.8438 9.4567 15.5433 10.1562 16.4062 10.1562Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 12.5C17.9688 15.5203 15.5203 17.9688 12.5 17.9688C9.47969 17.9688 7.03125 15.5203 7.03125 12.5H5.46875C5.46875 16.3833 8.61675 19.5312 12.5 19.5312C16.3833 19.5312 19.5312 16.3833 19.5312 12.5H17.9688Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_2475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmoji);
export default __webpack_public_path__ + "static/media/HappyEmoji.e88c28d33f80b98ecf961996c272b43d.svg";
export { ForwardRef as ReactComponent };